import Section from '../Section';

export default class CollectionList extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.theme.addBadges(this.element, 1000);
  }
}
